var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 2.99999C14.3856 2.78112 14.6454 2.6075 14.9314 2.48905C15.2173 2.3706 15.5238 2.30963 15.8334 2.30963C16.1429 2.30963 16.4494 2.3706 16.7353 2.48905C17.0213 2.6075 17.2812 2.78112 17.5 2.99999C17.7189 3.21886 17.8925 3.47869 18.011 3.76466C18.1294 4.05063 18.1904 4.35713 18.1904 4.66665C18.1904 4.97618 18.1294 5.28268 18.011 5.56865C17.8925 5.85461 17.7189 6.11445 17.5 6.33332L6.25002 17.5833L1.66669 18.8333L2.91669 14.25L14.1667 2.99999Z",
    stroke: "#667085",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7517ad6f1de426d0f43b46198d714979.svg";
export { ForwardRef as ReactComponent };